/**
 * From https://github.com/WindieChai/requirejs-global/blob/master/global.js
 * 
 * If wanting to depend on a non-amd library, use require(["plugins/global!library"]) or better yet
 * define a requirejs map.  For example:
 * 			map: {
 *				"*": {
 *					"jquery": "plugins/global!$",
 *					"underscore": "plugins/global!_",
 *					"backbone": "plugins/global!Backbone",
 *					"backbone.marionette": "plugins/global!Backbone.Marionette"
 *				}
 *			}
 *
 */

function ensure(parent, names, callback, timeout) {
    var actualName = names[0];

    if (typeof parent[actualName] === "undefined") {
        setTimeout(function () {
            console.debug(`looking for ${actualName}`);
            ensure(parent, names, callback, timeout + 100);
        }, timeout);
    } else if (names.length === 1) {
        callback(parent[actualName]);
    } else {
        names.shift();
        ensure(parent[actualName], names, callback, 50);
    }
}

export = {
    load: (name, req, onload, config) => {
        ensure(window, name.split("."), onload, 50);
    }
};
